// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconGlass = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M6.167 22L4 2h16l-2.167 20zm.495-14l-.434-4h11.544l-.434 4zm.216 2l1.084 10h8.076l1.084-10z"
    />
  );
export default SvgIconGlass;
